/* eslint-disable */
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App';
import router from './router';
import iView from 'iview';
import locale from 'iview/dist/locale/en-US';
import 'iview/dist/styles/iview.css';
import './assets/css/tailwind.css';
import i18n from './utils/i18n';

Vue.config.productionTip = false;
Vue.use(iView, { locale });
Vue.use(i18n);

try {
  const lang = localStorage.getItem('language') || 'en';
  document.documentElement.setAttribute('lang', lang === 'zh' ? 'zh-CN' : lang);
} catch (e) {
  // ignore
}

try {
  if (localStorage.getItem('theme') === 'dark') {
    document.documentElement.classList.add('theme-dark');
  }
} catch (e) {
  // ignore
}

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js